import { setLanguage } from '@ui5/webcomponents-base/dist/config/Language';
import { registerI18nLoader } from '@ui5/webcomponents-base/dist/i18nBundle';
import { SupportedLanguage, supportedLanguageKeys } from './types';
import { getPreferredLanguage, setDocumentDirection } from './utils';

export type AppPrefix = 'app-editor' | 'cloud-editor' | 'build-ui' | 'common';
export const bundles = [
  'app-editor.canvas',
  'app-editor.canvas-context-menu',
  'app-editor.header',
  'app-editor.publish',
  'app-build.page',
  'app-build.header',
  'app-build.history',
  'build-ui',
  'common.signed-out',
  'app-editor.marketplace-search',
  'app-editor.marketplace-detail',
  'app-editor.authentication',
  'app-editor.help',
  'app-editor.theme',
  'app-editor.navigation',
  'app-editor.variable-properties',
  'app-editor.variables',
  'app-editor.template-editor',
  'app-editor.angular',
  'app-editor.integrations',
] as const;
export type TranslationBundle = (typeof bundles)[number];

export const i18nFeatureFlagName = 'editorUiTranslations';

const fetchBundle = async (bundleName: TranslationBundle, localeId: SupportedLanguage) =>
  (
    await fetch(
      localeId === 'en_US_sappsd'
        ? `/assets/i18n/2Q/${bundleName}_${localeId}.json`
        : `/assets/i18n/${bundleName}_${localeId}.json`,
    )
  ).json();

export const initI18n = (language?: string) => {
  const currentLanguage = getPreferredLanguage(language);
  setDocumentDirection(currentLanguage);
  setLanguage(currentLanguage);

  supportedLanguageKeys.forEach((key) => {
    bundles.forEach((bundleName) => {
      registerI18nLoader(bundleName, key, async (localeId) => fetchBundle(bundleName, localeId as SupportedLanguage));
    });
  });
};
